module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAANUlEQVRIiWM07f/PQEOAYTgTLW3DBkYtHLVw1MJRC0ctHLVwEFrIgq2SpCUYTTRD3EIGBgYAeEID78H3y4YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/border_4.png
// module id = /3zs
// module chunks = 1